<template>
    <div>

        <div @click="$refs.file.click()" class="dropzone-container" @dragover="dragover" @dragleave="dragleave"
            @drop="drop">
            <img src="../assets/upload.svg" alt="upload-logo">
            <input type="file" name="file" id="fileInput" class="hidden-input" @click="$event.target.value = ''"
                @change="onChange" ref="file" accept=".csv,.txt" />

            <label class="file-label">
                <div v-if="isDragging">Release to drop files here.</div>
                <div v-else> <b>Choose a file</b> or drag it here.</div>
            </label>

        </div>
        <div class="preview-container mt-4" v-if="file.name.length > 0">
            <div class="preview-card">
                <div>
                    <img class="preview-img" src="../assets/file.svg" />
                    <p :title="file.name">
                        {{ file.name }}
                    </p>
                </div>
                <div>
                    <button class="close-button" type="button" @click="remove()" title="Remove file">
                        <b>&times;</b>
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Papa from 'papaparse';
import { mapMutations } from 'vuex'

export default {
    data() {
        return {
            isDragging: false,
            file: {
                name: "",
                data: null,
                content: [],
                type: "",
            },
            parsed: false,
        };
    },
    watch: {
        parsed() {
            if (this.parsed === true)
                this.SET_FILE({ content: this.file.content, type: this.file.type });
            else
                this.SET_FILE(null);
        }
    },


    methods: {
        ...mapMutations(["SET_FILE"]),
        onChange() {
            this.file.data = this.$refs.file.files[0];
            this.file.name = this.file.data.name;
            this.parseFile();
        },
        parseFile() {
            let tokens = this.file.name.split(".");
            let extension = tokens[tokens.length - 1];
            if (extension === "csv") {
                Papa.parse(this.file.data, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                        this.file.content = results;
                        let length = results.length;
                        if (length > 5000) length = 5000;
                        for (let i = 0; i < length; i++) {
                            let row = results[i];
                            this.file.content.push(row);
                        }

                        this.file.type = "csv";
                        this.parsed = true;
                    }.bind(this),
                });
            } else if (extension === "txt") {
                let reader = new FileReader();
                reader.onload = function (e) {
                    let content = e.target.result;
                    let paragraphs = content.split("\n");
                    let data = [];
                    let length = paragraphs.length;
                    if (length > 5000) length = 5000;
                    for (let i = 0; i < length; i++) {
                        let paragraph = paragraphs[i];
                        data.push(paragraph);
                    }
                    this.file.content = data;
                    this.file.type = "txt";
                    this.parsed = true;
                }.bind(this);
                reader.readAsText(this.file.data)

            }
        },

        generateThumbnail(file) {
            let fileSrc = URL.createObjectURL(file);
            setTimeout(() => {
                URL.revokeObjectURL(fileSrc);
            }, 1000);
            return fileSrc;
        },

        makeName(name) {
            return (
                name.split(".")[0].substring(0, 3) +
                "..." +
                name.split(".")[name.split(".").length - 1]
            );
        },

        remove() {
            this.file = {
                name: "",
                data: null,
                content: [],
                type: "",
            }
            this.parsed = false;
        },

        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },

        dragleave() {
            this.isDragging = false;
        },

        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChange();
            this.isDragging = false;
        },
    },
};
</script>

<style lang="scss">
.dropzone-container {
    padding: 4rem;


    transition: all 0.3s ease-in-out;
    cursor: pointer;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    margin-bottom: 1rem;

}

.hidden-input {
    display: none;

}

.file-label {
    font-size: 20px;
    display: block;
    cursor: pointer;
}

.preview-container {
    display: flex;
    margin-top: 2rem;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
}

.preview-card {
    display: flex;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 5px;
    margin-left: 5px;
}

.preview-img {
    width: 50px;
    height: 50px;

}

.close-button {
    all: unset;
    cursor: pointer;
    font-size: 20px;
    margin-left: 5px;
    margin-right: 5px;
    color: #a2a2a2;


}
</style>